export const GET_COMMISSION_SUCCESS = "GET_COMMISSION_SUCCESS";
export const GET_COMMISSION_ERROR = "GET_COMMISSION_ERROR";

export const UPDATE_COMMISSION_SUCCESS = "UPDATE_COMMISSION_SUCCESS";
export const UPDATE_COMMISSION_ERROR = "UPDATE_COMMISSION_ERROR";

export const CUSTOMER_COMMISSION_SUCCESS = "CUSTOMER_COMMISSION_SUCCESS";
export const CUSTOMER_COMMISSION_ERROR = "CUSTOMER_COMMISSION_ERROR";

export const DEALER_COMMISSION_SUCCESS = "DEALER_COMMISSION_SUCCESS";
export const DEALER_COMMISSION_ERROR = "DEALER_COMMISSION_ERROR";

export const MFR_COMMISSION_SUCCESS = "MFR_COMMISSION_SUCCESS";
export const MFR_COMMISSION_ERROR = "MFR_COMMISSION_ERROR";

export const DEALER_EARNING_SUCCESS = "DEALER_EARNING_SUCCESS";
export const DEALER_EARNING_ERROR = "DEALER_EARNING_ERROR";

export const MFR_EARNING_SUCCESS = "MFR_EARNING_SUCCESS";
export const MFR_EARNING_ERROR = "MFR_EARNING_ERROR";